export const discountsFields = {
    discountTarget: 'discountTarget',
    discountType: 'discountType',
    name: 'name',
    amount: 'amount',
    combinable: 'combinable',
} as const;
